/** @format */

import PropTypes from 'prop-types';

export function Toggle({label, checked, name, disabled, error, onChange, ...props}) {
    checked = !!checked;
    const hasError = !(error == null || error === '');
    return (
        <div
            className={`toggle-field field ${hasError && 'field--error'} ${
                disabled ? 'field--disabled' : ''
            }`}>
            <label>
                <input
                    className="control"
                    type="checkbox"
                    role="switch"
                    name={name}
                    disabled={disabled}
                    checked={checked}
                    onChange={e => onChange(e.target.checked)}
                    aria-invalid={hasError}
                    {...props}
                />
                <span>{label}</span>
            </label>
            {hasError && <p>{error}</p>}
        </div>
    );
}

Toggle.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    onChange: PropTypes.func
};

Toggle.defaultProps = {
    label: 'Label Name',
    disabled: false,
    checked: false,
    onChange: () => {}
};
